// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hU709","buttons":"styles_buttons__xdP3y"};